import { Box, Stack, Typography } from "@compass/core";
import {
  captionStyles,
  copyrightContainerStyles,
  sidePanelStyles,
  illustrationImageStyles,
  illustrationContainerStyles,
} from "../styles/authStyles";
import { BrandingHeader } from "./BrandingHeader";

export const LoginSidePanel = () => (
  <Stack sx={sidePanelStyles}>
    <Box sx={{ pt: 6 }}>
      <BrandingHeader />
    </Box>
     <Box sx={illustrationContainerStyles}>
      <Box
        component="img"
        src="/images/loginHero.png" 
        alt="Login illustration"
        sx={illustrationImageStyles}
      />

    </Box>
    <Box sx={copyrightContainerStyles}>
      <Typography variant="caption" sx={captionStyles}>
        Copyright © 2006-{new Date().getFullYear()} Cobro Consulting. All
        Rights Reserved.
      </Typography>
    </Box>
  </Stack>
);